import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import PinIcon from '../../assets/icons/pin.svg';
import { useTranslation } from 'react-i18next';
const RallyLocationRow = () => {
    const { t } = useTranslation();
    return (_jsxs("div", { className: "rally-location-row", children: [_jsx(PinIcon, {}), _jsx("span", { children: t('label.location_based_rally') })] }));
};
export default RallyLocationRow;
